<template>
  <div class="my-layout-box ">
    <!-- 订单信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>订单信息</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>入仓单号：</span>
            <i class="c-code-color"> {{ items.OrderNo }}</i>
          </li>
          <li>
            <span>单据状态：</span>
            <i
              :class="
                items.Status == 0
                  ? 'c-one-color'
                  : items.Status == 1
                  ? 'c-two-color'
                  : items.Status == 2
                  ? 'c-four-color'
                  : 'c-five-color'
              "
            >
              {{
                items.Status === 0
                  ? "待提交"
                  : items.Status === 1
                  ? "待审核"
                  : items.Status === 2
                  ? "已审核"
                  : "退回"
              }}</i
            >
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>操作模式：</span>
            <i
              :class="items.Status == 1 ? 'c-one-color' : items.Status == 2 ? 'c-two-color' : ''"
              >{{
                items.HandleSchema == 1 ? "中转配送" : items.HandleSchema == 2 ? "长期租仓" : ""
              }}</i
            >
          </li>
          <li>
            <span>下单日期: </span>
            <i>{{ items.CreatedAt | FormatDate }}</i>
          </li>
        </ul>
        <ul class="c-content-ul">
          <li>
            <span>代收代付：</span>
            <i :class="items.IsAgentPay ? 'c-three-color' : 'c-four-color'">{{
              items.IsAgentPay ? "是" : "否"
            }}</i>
          </li>
        </ul>

        <ul class="c-content-ul">
          <li>
            <span>供应商：</span>
            <i>{{ items.SupplierName }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 产品信息 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>产品信息</span>
      </section>
      <section class="c-content-box">
        <detail-list ref="detailList" :listMap="listMap"></detail-list>
      </section>
    </section>
    <!-- 仓库操作 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>仓库操作要求</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li v-if="items.IsMeasureWeightRequired">
            <span>测量磅重: </span>
            <i>{{ items.MeasureWeightRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsMeasureVolumeRequired">
          <li>
            <span>测量体积：</span>
            <i>{{ items.MeasureVolumeRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsCameraRequired">
          <li>
            <span>拍照：</span>
            <i>{{ items.CameraRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsHandleMarkRequired">
          <li>
            <span>处理标签：</span>
            <i>{{ items.HandleMarkRequired }}</i>
          </li>
        </ul>
        <ul class="c-content-ul" v-if="items.IsOtherRequired">
          <li>
            <span>其他需求：</span>
            <i>{{ items.OtherRequired }}</i>
          </li>
        </ul>
      </section>
    </section>
    <!-- 香港交货方式 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>香港交货方式</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>交货方式：</span>
            <i
              :class="
                items.HKReceivingType == 1
                  ? 'c-one-color'
                  : items.HKReceivingType == 2
                  ? 'c-two-color'
                  : items.HKReceivingType == 3
                  ? 'c-three-color'
                  : ''
              "
              >{{
                items.HKReceivingType == 1
                  ? "供应商配送"
                  : items.HKReceivingType == 2
                  ? "提货"
                  : items.HKReceivingType == 3
                  ? "快递"
                  : ""
              }}</i
            >
          </li>
          <li>
            <span>清关服务: </span>
            <i>{{ items.IsClearCustoms ? "需要清关" : "不需要清关" }}</i>
          </li>
        </ul>

        <!-- 供应商配送 -->
        <div v-if="items.HKReceivingType == 1">
          <ul class="c-content-ul">
            <li>
              <span>联系人: </span>
              <i>赵丽云</i>
            </li>
            <li>
              <span>联系电话: </span>
              <i>852-35292686</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址: </span>
              <i>九龍觀塘成業街19-21號 成業工業大廈3樓32-33室 </i>
            </li>
          </ul>
        </div>

        <!-- 快递 -->
        <div v-if="items.HKReceivingType == 2">
          <ul class="c-content-ul">
            <li>
              <span>联系人：</span>
              <i>{{ items.HKReceivingContact }}</i>
            </li>
            <li>
              <span>电话：</span>
              <i>{{ items.HKReceivingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址：</span>
              <i>{{ items.HKReceivingAddress }}</i>
            </li>
          </ul>

          <ul class="c-content-ul">
            <li>
              <span>提货备注：</span>
              <i>{{ items.PickupGoodsRemark }} </i>
            </li>
          </ul>
        </div>

        <div v-if="items.HKReceivingType == 3">
          <ul class="c-content-ul">
            <li>
              <span>快递公司：</span>
              <i>{{ items.HKReceivingExpressName }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>快递单号：</span>
              <i>{{ items.HKReceivingExpressNo }}</i>
            </li>
            <li>
              <span>快递费方式：</span>
              <i
                :class="
                  items.ReceiptExpressPayType == 1
                    ? 'c-one-color'
                    : items.ReceiptExpressPayType == 2
                    ? 'c-two-color'
                    : ''
                "
                >{{
                  items.ReceiptExpressPayType == 1
                    ? "到付"
                    : items.ReceiptExpressPayType == 2
                    ? "寄付"
                    : ""
                }}</i
              >
            </li>
          </ul>
        </div>
      </section>
    </section>

    <!-- 国内物流 -->
    <section class="c-box">
      <section class="c-header-title">
        <span>发货方式</span>
      </section>
      <section class="c-content-box">
        <ul class="c-content-ul">
          <li>
            <span>交货方式：</span>
            <i
              :class="
                items.StockOutType == 1
                  ? 'c-one-color'
                  : items.StockOutType == 2
                  ? 'c-two-color'
                  : items.StockOutType == 3
                  ? 'c-three-color'
                  : items.StockOutType == 4
                  ? 'c-four-color'
                  : ''
              "
              >{{
                items.StockOutType == 1
                  ? "BOM.AI送货"
                  : items.StockOutType == 2
                  ? "客户自提"
                  : items.StockOutType == 3
                  ? "快递"
                  : items.StockOutType == 4
                  ? "待确认"
                  : ""
              }}</i
            >
          </li>
        </ul>

        <!-- BOM.AI送货 -->
        <div v-if="items.StockOutType == 1">
          <ul class="c-content-ul">
            <li>
              <span>收货人：</span>
              <i>{{ items.ShippingContact }}</i>
            </li>
            <li>
              <span>收货电话：</span>
              <i>{{ items.ShippingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货公司：</span>
              <i>{{ items.ShippingCompanyName }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址：</span>
              <i>{{ items.ShippingFullAddress }}</i>
            </li>
          </ul>
        </div>

        <!-- 快递 -->
        <div v-if="items.StockOutType == 3">
          <ul class="c-content-ul">
            <li>
              <span>收货人：</span>
              <i>{{ items.ShippingContact }}</i>
            </li>
            <li>
              <span>收货电话：</span>
              <i>{{ items.ShippingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货公司：</span>
              <i>{{ items.ShippingCompanyName }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>收货地址：</span>
              <i>{{ items.ShippingFullAddress }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>快递公司: </span>
              <i>{{ items.DeliveryExpressCompany }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span style="width: 90px">快递费方式：</span>
              <i>{{
                items.SendExpressPayType == 1
                  ? "到付"
                  : items.SendExpressPayType == 2
                  ? "寄付"
                  : items.SendExpressPayType == 3
                  ? "第三方支付"
                  : ""
              }}</i>
            </li>

            <li v-if="items.SendExpressPayType == 3">
              <span>第三方账户: </span>
              <i>{{ items.ThirdExpressAccount }}</i>
            </li>
          </ul>
          <ul class="c-orders-ul">
            <li>
              <span>快递备注: </span>
              <i>{{ items.DeliveryRemark }}</i>
            </li>
          </ul>
        </div>

        <!-- 客户自提 -->
        <div v-if="items.StockOutType == 2">
          <ul class="c-content-ul">
            <li>
              <span>提货人：</span>
              <i>{{ items.ShippingContact }}</i>
            </li>
            <li>
              <span>电话：</span>
              <i>{{ items.ShippingMobile }}</i>
            </li>
          </ul>
          <ul class="c-content-ul">
            <li>
              <span>身份证号：</span>
              <i>{{ items.ShippingCode }}</i>
            </li>
          </ul>
        </div>

        <div style="margin-top: 5px">
          <ul class="c-content-ul" v-if="items.IsCameraRequiredForSend">
            <li>
              <span>拍照： </span>
              <i> {{ items.CameraRequiredForSend }}</i>
            </li>
          </ul>
          <ul class="c-content-ul" v-if="items.IsHandleMarkRequiredForSend">
            <li>
              <span>处理标签：</span>
              <i> {{ items.HandleMarkRequiredForSend }}</i>
            </li>
          </ul>
          <ul class="c-content-ul" v-if="items.IsOtherRequiredForSend">
            <li>
              <span>其他需求: </span>
              <i> {{ items.OtherRequiredForSend }}</i>
            </li>
          </ul>
        </div>
      </section>
    </section>
  </div>
</template>
<script>
import { getHKOrderDetail } from "~/api/order";
import { hkOrderDetailData } from "./config";
import DetailList from "~/components/List/DetailView.vue";
export default {
  name: "hkOrderDetail",
  components: {
    DetailList
  },
  data() {
    return {
      items: {},
      listMap: hkOrderDetailData
    };
  },
  methods: {
    async getData() {
      const { id } = this.$route.query;
      const params = {
        Id: id
      };
      let data = await getHKOrderDetail(params);
      this.items = data;
      this.$refs.detailList.getList(data.HKAgentOrderDetail);
    }
  },
  async created() {
    await this.getData();
  }
};
</script>
